export const DateOptions = ["Today", "Tomorrow", "This weekend", "Next month"];
export const DurationOptions = ["1 week", "2 weeks", "1 month", "3 months"];
export const CirculationOptions = ["1,000", "10,000", "100,000", "1,000,000"];
export const QunatityOptions = ["1", "2", "3", "4", "5"];
export const AvailOptions = ["Single", "Unlimited"];
